import { useEffect, useState } from "react";
import { getInternalAppStatusEmitter } from "../../config";
import { RedoCheckoutButtonClickedEvent } from "../internal-app-events";

export function useCheckoutButtonClicked() {
  const [anyCheckoutButtonClicked, setAnyCheckoutButtonClicked] =
    useState<boolean>(false);

  useEffect(() => {
    const internalEmitter = getInternalAppStatusEmitter();
    const listener = (_event: RedoCheckoutButtonClickedEvent) => {
      setAnyCheckoutButtonClicked(true);
    };

    internalEmitter.on("RedoCheckoutButtonClickedEvent", listener);

    return () => {
      internalEmitter.off("RedoCheckoutButtonClickedEvent", listener);
    };
  }, []);

  return { anyCheckoutButtonClicked, setAnyCheckoutButtonClicked };
}
